/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Default_BadgeInputs */

const cs_templates_default_badge = /** @type {(inputs: Templates_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí`)
};

const en_templates_default_badge = /** @type {(inputs: Templates_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default`)
};

/**
* | output |
* | --- |
* | "Default" |
*
* @param {Templates_Default_BadgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_default_badge = /** @type {((inputs?: Templates_Default_BadgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Default_BadgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_default_badge(inputs)
	return cs_templates_default_badge(inputs)
});